/* libs/oyan-ui/src/lib/features/sites/components/site-info-form/site-info-form.component.scss */
.site-info__image img {
  max-width: 365px;
}
/*# sourceMappingURL=site-info-form.component.css.map */
